// src/components/ui/StatusBadge.tsx
import type { ReactNode } from 'react';
import { WorkflowStatus, type StockStatus } from '@/lib/types/workflow';
import { fonts } from '@/lib/tokens';
import { statusColors } from '@/lib/statusColors';

type HoldStatus = 'HOLD_ACTIVE' | 'HOLD_EXPIRED';

type Props = {
  status: WorkflowStatus | StockStatus | HoldStatus;
  children?: ReactNode;
};

const LABEL_FOR_STATUS: Record<string, string> = {
  [WorkflowStatus.PROCESSING]: 'Processing',
  [WorkflowStatus.PENDING_REVIEW]: 'Pending Review',
  [WorkflowStatus.STOCK_RESERVATION]: 'Reserving Stock',
  [WorkflowStatus.EDIT_MODE]: 'Edit Mode',
  [WorkflowStatus.FINALIZE]: 'Finalize',
  [WorkflowStatus.APPROVED]: 'Approved',
  [WorkflowStatus.SENT]: 'Sent',
  [WorkflowStatus.REJECTED]: 'Rejected',
  IN_STOCK: 'In Stock',
  LOW_STOCK: 'Low Stock',
  SUBSTITUTION: 'Substitution',
  UNAVAILABLE: 'Unavailable',
  HOLD_ACTIVE: 'On Hold',
  HOLD_EXPIRED: 'Hold Expired',
};

export function StatusBadge({ status, children }: Props) {
  const label = children ?? LABEL_FOR_STATUS[status] ?? String(status);
  const t = statusColors(status);

  return (
    <span
      className="uppercase tracking-[0.14em]"
      style={{
        fontFamily:    fonts.mono,
        display:       'inline-flex',
        alignItems:    'center',
        gap:           6,
        fontSize:      10.5,
        lineHeight:    1,
        padding:       '6px 10px',
        borderRadius:  999,
        color:         t.color,
        background:    t.background,
        border:        `1px solid ${t.border}`,
        whiteSpace:    'nowrap',
      }}
    >
      <span
        aria-hidden
        style={{
          display: 'inline-block',
          width: 5,
          height: 5,
          borderRadius: 999,
          background: t.color,
        }}
      />
      {label}
    </span>
  );
}
